const ptPT = {};

export default ptPT;
